import {I18nextProvider as BaseProvider} from 'react-i18next';
import i18n from './i18n';

export default function I18NextProvider({children}) {
  return <BaseProvider i18n={i18n}>{children}</BaseProvider>;
}
